const minInput = document.getElementById("Filter-Price-GTE");
const mirrormin = document.getElementById("gte");
const maxInput = document.getElementById("Filter-Price-LTE");
const mirrormax = document.getElementById("lte");

minInput.addEventListener("input", () => {
  mirrormin.value = minInput.value
});

mirrormin.addEventListener("input", () => {
  minInput.value = mirrormin.value
});

maxInput.addEventListener("input", () => {
  mirrormax.value = maxInput.value
});

mirrormax.addEventListener("input", () => {
  maxInput.value = mirrormax.value
});
